import { Plant } from '@cemex-core/cmx-api/models/order-management/plant';
import {
  ProductPlantsActions,
  LOAD_PRODUCT_PLANTS_COMPLETE,
  RESET,
  ADD_PRODUCT_PLANT,
} from '../../actions/product-plants.actions';

export interface ProductPlantsState {
  plants: Plant[];
}

export const initialState: ProductPlantsState = {
  plants: [],
};

export function productPlantsReducer(state = initialState, action: ProductPlantsActions): ProductPlantsState {
  switch (action.type) {
    case LOAD_PRODUCT_PLANTS_COMPLETE: {
      return {
        ...state,
        plants: action.payload.plants,
      } as ProductPlantsState;
    }
    case ADD_PRODUCT_PLANT: {
      return {
        ...state,
        plants: [...state.plants.filter(plant => plant.id !== action.payload.id), action.payload],
      };
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
